import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import AutoComplete from '../select/AutoComplete';
var messages = defineMessages({
    ToDo: {
        id: 'ToDo',
        defaultMessage: 'To do',
    },
    InProgress: {
        id: 'InProgress',
        defaultMessage: 'In progress',
    },
    Done: {
        id: 'Done',
        defaultMessage: 'Done',
    },
    Blocked: {
        id: 'Blocked',
        defaultMessage: 'Blocked',
    },
    NotDone: {
        id: 'NotDone',
        defaultMessage: 'NotDone',
    },
});
export var StatusSelect = function (_a) {
    var initialValue = _a.initialValue, placeholder = _a.placeholder, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    var statuses = useMemo(function () { return [
        {
            key: 0,
            label: formatMessage(messages.ToDo),
        },
        {
            key: 1,
            label: formatMessage(messages.InProgress),
        },
        {
            key: 2,
            label: formatMessage(messages.Done),
        },
        {
            key: -1,
            label: formatMessage(messages.NotDone),
        },
    ]; }, [formatMessage]);
    var initialSelectedItem = useMemo(function () {
        return initialValue || parseInt(initialValue) === 0
            ? statuses.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === parseInt(initialValue); })
            : undefined;
    }, [initialValue, statuses]);
    return (_jsx(AutoComplete, { items: statuses, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: function (item) { return onChange(item === null || item === void 0 ? void 0 : item.key); } }));
};
export var FilterStatusSelect = function (_a) {
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(StatusSelect, { onChange: function (value) {
                var _a;
                return setFilter((_a = {}, _a[item] = value !== null && value !== void 0 ? value : undefined, _a));
            }, initialValue: activeFilters[item], placeholder: label })),
    });
};
